// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_Delayed from "../Restaumatic.Form.Delayed/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_FormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Totality from "../Restaumatic.Form.Totality/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
var relax = /* #__PURE__ */ Restaumatic_Form_DynamicResult.relax();
var queryImpl = /* #__PURE__ */ Restaumatic_Form_Query.queryImpl(/* #__PURE__ */ Restaumatic_Form_FormField["queryFormField$prime"](Type_Equality.refl));
var map = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var pure = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Identity.applicativeIdentity);
var mergeFormField$prime = /* #__PURE__ */ Restaumatic_Form_FormField["mergeFormField$prime"](Type_Equality.refl);
var merge = /* #__PURE__ */ Restaumatic_Form_Internal.merge(mergeFormField$prime);
var merge_Record = /* #__PURE__ */ Restaumatic_Form_Internal.merge_Record(Restaumatic_Form_Internal.asRecordRecord)();
var mergeRecordCons = /* #__PURE__ */ Restaumatic_Form_Internal.mergeRecordCons({
    reflectSymbol: function () {
        return "exists";
    }
});
var mergeRecordCons1 = /* #__PURE__ */ Restaumatic_Form_Internal.mergeRecordCons({
    reflectSymbol: function () {
        return "subform";
    }
})(Restaumatic_Form_Internal.mergeRecordNil);
var map1 = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var make = /* #__PURE__ */ Restaumatic_Form_Internal.make(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost))(/* #__PURE__ */ Restaumatic_Form_FormField.initializeNoInitialValueI(/* #__PURE__ */ Restaumatic_Form_FormField.initializeRecordFormField(/* #__PURE__ */ Data_NamedParams.fromDefaults1()())(Restaumatic_Form_Totality.isTotalityPartial)()(/* #__PURE__ */ Restaumatic_Form_FormField.initialValueSomeInitialVa(Type_Equality.refl))));
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Restaumatic_Form_Internal.bindFormDefM);
var map2 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Delayed.functorDelayed);
var pure4 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordNil));
var addContext = /* #__PURE__ */ Restaumatic_Form_Internal.addContext(Restaumatic_Form_FormField["addContextFormField$prime"]);
var OptionalField = function (x) {
    return x;
};
var queryMaybeOptionalField$prime = function () {
    return function (dictQuery) {
        var queryImpl1 = Restaumatic_Form_Query.queryImpl(dictQuery);
        return {
            queryImpl: function (s) {
                return function (v) {
                    return Restaumatic_Form_DynamicResult.andThen(relax(queryImpl(s)(v.exists)))(function (v1) {
                        if (v1) {
                            return map(Data_Maybe.Just.create)(relax(queryImpl1(s)(v.subform)));
                        };
                        return pure(Data_Maybe.Nothing.value);
                    });
                };
            }
        };
    };
};
var optionalFieldLikeOptional = {
    toDelayedOptionalField: /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Delayed.applicativeDelayed),
    existsWrapped: function (v) {
        return pure1(v.exists);
    },
    subformWrapped: function (v) {
        return pure1(v.subform);
    }
};
var mergeMaybeOptionalField$prime = function (dictMerge) {
    var merge1 = Restaumatic_Form_Internal.merge(merge_Record(mergeRecordCons(mergeRecordCons1(dictMerge)()()()())(mergeFormField$prime)()()()()));
    return {
        merge: function (v) {
            return function (v1) {
                if (v instanceof Data_Maybe.Nothing) {
                    return merge(false)(v1.exists);
                };
                if (v instanceof Data_Maybe.Just) {
                    return merge1({
                        exists: true,
                        subform: v.value0
                    })(v1);
                };
                throw new Error("Failed pattern match at Restaumatic.Form.Optional (line 89, column 1 - line 93, column 45): " + [ v.constructor.name, v1.constructor.name ]);
            };
        }
    };
};
var makeEmptyOptionalField$primePa = function (dictMakeEmpty) {
    var makeEmptyImpl = Restaumatic_Form_Internal.makeEmptyImpl(dictMakeEmpty);
    return {
        makeEmptyImpl: function (opts) {
            return function __do() {
                var exists_ = map1(Data_Tuple.fst)(Specular_FRP_Host.runHost(make(append(opts.name)([ "__exists__" ]))(function (v) {
                    return Restaumatic_Form_Internal.withInitialValue(false)({});
                })))();
                var subform_ = makeEmptyImpl({
                    name: append(opts.name)([ "__value__" ])
                })();
                return {
                    exists: exists_,
                    subform: subform_
                };
            };
        }
    };
};
var initializeNoInitialValueR = function (dictFromDefaults) {
    var fromDefaults = Data_NamedParams.fromDefaults(dictFromDefaults);
    return function (dictInitialize) {
        var makeImpl = Restaumatic_Form_Internal.makeImpl(dictInitialize);
        return function (dictInitialize1) {
            var makeImpl1 = Restaumatic_Form_Internal.makeImpl(dictInitialize1);
            return {
                makeImpl: function (s) {
                    return function (opts) {
                        return bind1(makeImpl(s)({
                            name: append(opts.name)([ "__exists__" ])
                        }))(function (exists_) {
                            return bind1(makeImpl1(s)({
                                name: append(opts.name)([ "__value__" ])
                            }))(function (subform_) {
                                var field = {
                                    exists: exists_.field,
                                    subform: subform_.field
                                };
                                return pure3({
                                    field: field,
                                    init: function (v) {
                                        return function (initializer) {
                                            var params = fromDefaults({
                                                exists: Restaumatic_Form_Internal.NoInitializer.value,
                                                item: Restaumatic_Form_Internal.NoInitializer.value
                                            })(initializer);
                                            return discard1(exists_.init(new Restaumatic_Form_Internal.SomeInitialValue(false))(params.exists))(function () {
                                                return subform_.init(Restaumatic_Form_Internal.NoInitialValue.value)(params.item);
                                            });
                                        };
                                    }
                                });
                            });
                        });
                    };
                }
            };
        };
    };
};
var initializeMetadataInitial = function (dictAddMetadata) {
    return function (dictInitialize) {
        return {
            makeImpl: Restaumatic_Form_Internal.makeWithMetadataInitializer(dictInitialize)(dictAddMetadata)
        };
    };
};
var initializeInitialValueIni = function (dictMakeWithInitialValueInitializer) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithInitialValueInitializer(dictMakeWithInitialValueInitializer)
    };
};
var initializeContextInitiali = function (dictAddContext) {
    return function (dictInitialize) {
        return {
            makeImpl: Restaumatic_Form_Internal.makeWithContextInitializer(dictInitialize)(dictAddContext)
        };
    };
};
var hasFieldOptionalField$prime = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return {
        getField: function (label) {
            return function (v) {
                return getField(label)(v.subform);
            };
        }
    };
};
var toDelayedOptionalField = function (dict) {
    return dict.toDelayedOptionalField;
};
var subformWrapped = function (dict) {
    return dict.subformWrapped;
};
var subform = function (dictOptionalFieldLike) {
    var subformWrapped1 = subformWrapped(dictOptionalFieldLike);
    return function (dictUnwrapFunctor) {
        var $134 = Restaumatic_Form_Delayed.unwrapFunctor(dictUnwrapFunctor);
        return function ($135) {
            return $134(subformWrapped1($135));
        };
    };
};
var subform1 = /* #__PURE__ */ subform(optionalFieldLikeOptional)(Restaumatic_Form_Delayed.unwrapFunctorIdentity);
var optionalItem = function (v) {
    return function (v1) {
        return v(v1.subform);
    };
};
var existsWrapped = function (dict) {
    return dict.existsWrapped;
};
var exists = function (dictOptionalFieldLike) {
    var existsWrapped1 = existsWrapped(dictOptionalFieldLike);
    return function (dictUnwrapFunctor) {
        var $136 = Restaumatic_Form_Delayed.unwrapFunctor(dictUnwrapFunctor);
        return function ($137) {
            return $136(existsWrapped1($137));
        };
    };
};
var exists1 = /* #__PURE__ */ exists(optionalFieldLikeOptional)(Restaumatic_Form_Delayed.unwrapFunctorIdentity);
var optionalFieldLikeDelayedO = {
    toDelayedOptionalField: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn),
    existsWrapped: function (x) {
        return map2(exists1)(toDelayedOptionalField(optionalFieldLikeDelayedO)(x));
    },
    subformWrapped: function (x) {
        return map2(subform1)(toDelayedOptionalField(optionalFieldLikeDelayedO)(x));
    }
};
var dumpStateOptionalField = {
    dumpState: function (v) {
        return pure4(encode({}));
    }
};
var addContextOptionalField = function (dictAddContext) {
    var addContext1 = Restaumatic_Form_Internal.addContext(dictAddContext);
    return {
        addContext: function (ctx) {
            return function (v) {
                return function __do() {
                    addContext(ctx)(v.exists)();
                    return addContext1(ctx)(v.subform)();
                };
            };
        }
    };
};
export {
    existsWrapped,
    subformWrapped,
    toDelayedOptionalField,
    OptionalField,
    optionalItem,
    exists,
    subform,
    makeEmptyOptionalField$primePa,
    initializeNoInitialValueR,
    initializeInitialValueIni,
    initializeContextInitiali,
    initializeMetadataInitial,
    mergeMaybeOptionalField$prime,
    addContextOptionalField,
    queryMaybeOptionalField$prime,
    dumpStateOptionalField,
    hasFieldOptionalField$prime,
    optionalFieldLikeOptional,
    optionalFieldLikeDelayedO
};
